import React from "react";
import { motion } from "framer-motion";

const COLLAGE_URL =
  "https://customer-assets.emergentagent.com/job_future-tech-site-6/artifacts/yb9405al__.png";

const FeatureBanner = () => {
  return (
    <section
      id="feature-banner"
      className="relative py-10 md:py-16 lg:py-20 overflow-hidden"
      data-testid="feature-banner-section"
    >
      {/* Ambient glow */}
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[80%] h-[400px] rounded-full bg-[#00E5FF]/[0.06] blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-[#39FF14]/[0.04] blur-3xl pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="absolute -inset-1 bg-gradient-to-br from-[#00E5FF]/35 via-transparent to-[#39FF14]/30 rounded-3xl blur-xl opacity-80" />
          <div className="relative rounded-2xl overflow-hidden border border-[#00E5FF]/30 bg-[#07090f]">
            <img
              src={COLLAGE_URL}
              alt=""
              loading="lazy"
              className="relative block w-full h-auto object-contain"
              data-testid="feature-banner-image"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FeatureBanner;
